export const centerAdminMenus: any = [
  {
    name: "Manage Staff",
    image: "../../assets/images/managestaff.svg",
    url: "/manageStaff",
  },
  {
    name: "Contacts - Referral Doctors",
    image: "../../assets/images/contactReferrals.svg",
    url: "/contactReferrals",
  },
  {
    name: "Bed management",
    image: "../../assets/images/bedManagement.svg",
    url: "/bedManagement",
  },
  {
    name: "Manage Patients",
    image: "../../assets/images/managestaff.svg",
    url: "/managePatients",
  },
  {
    name: "Merge Patients",
    image: "../../assets/images/mergeIcon.svg",
    url: "/mergePatients",
  },
  {
    name: "Transfer Patients",
    image: "../../assets/images/managestaff.svg",
    url: "/transferPatients",
  },
  {
    name: "Approval Requests",
    image: "../../assets/images/id_generation.svg",
    url: "/approvalRequests",
  },
  {
    name: "Service",
    image: "../../assets/images/Billing_admin.svg",
    url: "/Service",
  },
]

export const systemAdminMenus: any = [
  {
    name: "Manage Staff",
    image: "../../assets/images/managestaff.svg",
    url: "/manageStaff",
  },
  {
    name: "Contacts - Referral Doctors",
    image: "../../assets/images/contactReferrals.svg",
    url: "/contactReferrals",
  },
  {
    name: "Bed management",
    image: "../../assets/images/bedManagement.svg",
    url: "/bedManagement",
  },
  {
    name: "Manage Patients",
    image: "../../assets/images/managestaff.svg",
    url: "/managePatients",
  },
  {
    name: "Merge Patients",
    image: "../../assets/images/mergeIcon.svg",
    url: "/mergePatients",
  },
  // {
  //   name: "Manage Communications",
  //   image: "../../assets/images/manage_communications.svg",
  //   url: "/manageCommunications",
  // },
  {
    name: "Manage Centers",
    image: "../../assets/images/managestaff.svg",
    url: "/manageCenters",
  },
  {
    name: "Automatic ID Generation",
    image: "../../assets/images/id_generation.svg",
    url: "/automaticIDGeneration",
  },
  // {
  //   name: "Billing",
  //   image: "../../assets/images/Billing_admin.svg",
  //   url: "/billing/admin",
  // },
  {
    name: "Forms and Templates",
    image: "../../assets/images/formsAndTemplates.svg",
    url: "/forms",
  },
  {
    name: "Edit Forms and Templates",
    image: "../../assets/images/formsAndTemplates.svg",
    url: "/forms-v2",
  },
  {
    name: "Drugs",
    image: "../../assets/images/Prescriptions.svg",
    url: "/prescriptions",
  },
  {
    name: "Service",
    image: "../../assets/images/Billing_admin.svg",
    url: "/Service",
  },
  {
    name: "Print Configurations",
    image: "../../assets/images/printConfiguration.svg",
    url: "/printConfiguration",
  },
  {
    name: "Add SubCategory",
    image: "../../assets/images/procedure.svg",
    url: "/SubCategoryMenu",
  },
  {
    name: "Manage Paytm Merchants",
    image: "../../assets/images/Billing_admin.svg",
    url: "/managePaytmMerchants",
  },
]
